/* @flow */
import { Observable } from 'rxjs';
import { prop, path } from 'ramda';
import { Map, fromJS, List } from 'immutable';
import { stringify } from 'querystring';
import { combineEpics, ActionsObservable } from 'redux-observable';
import { LOCATION_CHANGE } from 'react-router-redux';

import { SCORES_ENDPOINT } from './constants';
import {
  UPDATE_PAGE_FILTERS,
  RESET_PAGE_FILTERS,
  FETCH_ENTITY_SCORES_PAGE,
  FETCH_ENTITY_SCORES_PAGE_SUCCESS,
  FETCH_ENTITY_SCORES_PAGE_FAILURE
} from './action-types';
import * as Types from './types';
import * as getters from './getters.js';
import { error } from 'modules/alerts/actions';
import { normalizeScoresEntry } from './utils';

const formatSearchRequest = (payload: Map<string, any>) => {
  const sort = payload.getIn(['sort', 'sort'], {});
  const params = {
    sort: sort.sortBy + ',' + sort.sortDirection,
    pageNumber: payload.get('pageNumber'),
    pageSize: payload.get('pageSize')
  };
  return stringify(params);
};

/* Fetches all scores entries and aliases */
const fetchScoresPageEpic = (action$, store, { ajax }) =>
  action$
    .ofType(FETCH_ENTITY_SCORES_PAGE, UPDATE_PAGE_FILTERS, RESET_PAGE_FILTERS)
    .mergeMap(() => {
      const currentQuery = getters.currentQueryWithEntities(store.getState());
      return ajax
        .postJSON(
          SCORES_ENDPOINT + '?' + formatSearchRequest(currentQuery),
          currentQuery.get('query').toJS()
        )
        .map(prop('response'))
        .map(response => ({
          type: FETCH_ENTITY_SCORES_PAGE_SUCCESS,
          payload: Types.ScoresPage(response)
        }))
        .catch(err =>
          Observable.of({ type: FETCH_ENTITY_SCORES_PAGE_FAILURE })
        );
    });

const hasNextPage = payload =>
  payload.get('hasNext', false) && !payload.get('empty', true);

// /*  FIXME: Let's finish this later */
// const fetchNextScoresPageEpic = (action$, store, { ajax }) =>
//   action$.ofType(FETCH_ENTITY_SCORES_PAGE_SUCCESS).map(({ payload }) => {
//     if (hasNextPage(payload)) {
//       return {
//         type: 'FETCH_NEXT_ENTITY_SCORES_PAGE'
//       };
//     } else {
//       return {
//         type: 'FETCH_ALL_ENTITY_SCORES_SUCCESS'
//       };
//     }
//   });

export default combineEpics(
  fetchScoresPageEpic
  // fetchNextScoresPageEpic
);



// WEBPACK FOOTER //
// ./src/app/modules/entity-scores/epics.js